/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

/* eslint-disable react/no-unescaped-entities */
import React from 'react';

const About = () => (
  <div id="tf-about">
    <div className="container">
      <div className="row">
        <div className="col-md-4"><img className="img-fluid" src="img/report.jpg" alt="Report" /></div>
        <div className="col-md-8">
          <div className="about-text">
            <div className="section-title">
              <h2><strong> about us</strong></h2>
              <hr />
              <div className="clearfix" />
            </div>
            <p className="intro">Since 2006 NoWatt has been monitoring the operational profiles of thousands of appliances. We've terabytes of high resolution IoT data, but the most valuable lessons aren't within it; they're from our experience with operators, maintenance companies, and manufacturers. The lessons:</p>
            <ul className="about-list">
              <li><span className="fa fa-dot-circle-o" /> <em>Data alone will likely save you nothing</em></li>
              <li><span className="fa fa-dot-circle-o" /> <em>Data has to be targeted and actionable</em></li>
              <li><span className="fa fa-dot-circle-o" /> <em>You need an AI engine to classify data</em></li>
            </ul>
            <p className="intro">We have the data <strong>and</strong> know what to do with it: <a className="page-scroll" href="#tf-contact"> contact us</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default About;
